import React from 'react';
interface LanguageSelectorProps {
  onSelect: (lang: string) => void;
}
const LANGUAGES = [{
  code: 'en',
  label: 'English',
  flag: '🇬🇧'
}, {
  code: 'no',
  label: 'Norsk',
  flag: '🇳🇴'
}, {
  code: 'sv',
  label: 'Svenska',
  flag: '🇸🇪'
}, {
  code: 'da',
  label: 'Dansk',
  flag: '🇩🇰'
}];
export function LanguageSelector({
  onSelect
}: LanguageSelectorProps) {
  return <div className="flex flex-col h-full w-full justify-center items-center animate-fade-in-up" data-id="element-30">
      <div className="mb-10 text-center" data-id="element-31">
        <div className="text-solventum-primary text-sm font-body uppercase tracking-widest mb-6" data-id="element-32">
          Solventum
        </div>

        {/* Big 18 visual */}
        <div className="relative inline-flex items-center justify-center mb-6" data-id="element-33">
          <div className="absolute w-24 h-24 rounded-full bg-solventum-primary/10 animate-pulse" data-id="element-34" />
          <span className="relative text-6xl font-headline font-extrabold text-solventum-primary" data-id="element-35">
            18
          </span>
        </div>

        <h1 className="text-2xl md:text-3xl font-extrabold text-white mb-4 leading-tight max-w-md" data-id="element-36">
          Invest the next 18 seconds to see how you can save 18 minutes on all
          future bonding appointments!
        </h1>
        <p className="text-white/50 font-body text-sm" data-id="element-37">
          Select your language to start
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 w-full max-w-xs" data-id="element-38">
        {LANGUAGES.map(lang => <button key={lang.code} onClick={() => onSelect(lang.code)} className="flex flex-col items-center gap-2 bg-white/5 border-2 border-white/10 hover:border-solventum-primary rounded-2xl py-6 px-4 transition-all duration-300 hover:bg-white/10 group" data-id="element-39">
            <span className="text-4xl mb-1" data-id="element-40">{lang.flag}</span>
            <span className="text-white font-headline font-bold text-base group-hover:text-solventum-primary transition-colors" data-id="element-41">
              {lang.label}
            </span>
          </button>)}
      </div>
    </div>;
}